import { Serializable } from '@/models/core/serializable';

export class CompetencySetting implements Serializable<CompetencySetting> {
  competencyID: number;
  competencyType: number;
  isValid: boolean;
  name: string;
  questionCount: number;

  deserialize(input: any): CompetencySetting {
    this.competencyID = input.competencyID;
    this.competencyType = input.competencyType;
    this.isValid = input.isValid;
    this.name = input.name;
    this.questionCount = input.questionCount;
    return this;
  }
}
